"use client";

import { useEffect, useRef } from "react";
import { trackChokh, type ChokhEventName, type ChokhEventProps } from "@/lib/chokh";

type Props = {
  name: ChokhEventName;
  props?: ChokhEventProps;
};

/**
 * Sends one Chokh event when a server-rendered page mounts (`AN-INT01`).
 *
 * The pages that carry it are Server Components and `pa()` is a browser
 * interface, so the event needs a client boundary of its own. A client
 * navigation from one course to another keeps this component mounted and only
 * changes the props, so what has already been sent is remembered by value
 * rather than by mount.
 */
export function ChokhEvent({ name, props }: Props) {
  const sent = useRef<string | null>(null);

  useEffect(() => {
    const key = `${name}:${JSON.stringify(props ?? {})}`;
    if (sent.current === key) return;
    sent.current = key;
    trackChokh(name, props);
  }, [name, props]);

  return null;
}
